/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const WebsiteTypeSchema = z.enum(["BUSINESS_PRIMARY", "BUSINESS_SUPPORT", "BUSINESS_SALES", "BUSINESS_OTHER"])
